import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({}, km({

  RECHARGE_GET_DETAIL_START: null,
  RECHARGE_GET_DETAIL_SUCCESS: null,
  RECHARGE_GET_DETAIL_ERROR: null,
  RECHARGE_GET_DETAIL_ERROR_EMPTY: null,
  RECHARGE_GET_DETAIL_ERROR_TMR: null,

  RECHARGE_PHONE_NUMBER: null,
  RECHARGE_FLOW_NUMBER: null,
  RECHARGE_TO_ORDER_AFRER_LOGIN: null,

  RECHARGE_GET_RECOMMEND_LIST_SUCCESS: null,
  RECHARGE_GET_RECOMMEND_LIST_ERROR: null,
  RECHARGE_GET_RECOMMEND_LIST_EMPTY: null,
  RECHARGE_GETTER_RECOMMEND_LIST: null,
}))
